/* istanbul ignore file */

import React, { FC, useCallback, useState } from 'react';
import dynamic from 'next/dynamic';
import DevToolsTrigger from './DevToolsTrigger';
import { useDevToolPermissions } from './utils';

interface Props {
  className?: string;
}

const DevToolsModal = dynamic(() => import('./DevToolsModal'));

const DevTools: FC<Props> = ({ className }) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [wasOpened, setWasOpened] = useState<boolean>(false);
  const toggleModal = useCallback(() => {
    setWasOpened(true);
    setShowModal(v => !v);
  }, [setShowModal]);

  if (!useDevToolPermissions()) return null;

  return (
    <>
      <DevToolsTrigger onClick={toggleModal} className={className} />
      {wasOpened && <DevToolsModal isOpen={showModal} handleClose={toggleModal} />}
    </>
  );
};

export default DevTools;
